// Super-admin client for the Threat Insights catalog + per-org
// overrides.
//
// All endpoints sit under /api/admin/threat-insights and require
// SUPER_ADMIN auth on the backend.

import adminAxios from "./adminAxios";

const threatInsightAdmin = {
  // ── Rules catalog ─────────────────────────────────────────────
  searchRules: (params) =>
    adminAxios.get("/threat-insights/rules", { params }),
  getFacets: () => adminAxios.get("/threat-insights/rules/facets"),
  updateRule: (id, body) =>
    adminAxios.patch(`/threat-insights/rules/${id}`, body),

  // ── Per-organisation overrides ────────────────────────────────
  listOrganisations: () =>
    adminAxios.get("/threat-insights/organisations"),
  listOverrides: (orgId) =>
    adminAxios.get(`/threat-insights/organisations/${orgId}/overrides`),
  upsertOverride: (orgId, ruleId, body) =>
    adminAxios.put(
      `/threat-insights/organisations/${orgId}/rules/${ruleId}`,
      body
    ),
  deleteOverride: (orgId, ruleId) =>
    adminAxios.delete(
      `/threat-insights/organisations/${orgId}/rules/${ruleId}`
    ),

  // ── TI-9 (2026-07-03): suppressions CRUD ─────────────────────
  listSuppressions: (params) =>
    adminAxios.get("/threat-insights/suppressions", { params }),
  createSuppression: (body) =>
    adminAxios.post("/threat-insights/suppressions", body),
  extendSuppression: (id, body) =>
    adminAxios.patch(`/threat-insights/suppressions/${id}`, body),
  deleteSuppression: (id) =>
    adminAxios.delete(`/threat-insights/suppressions/${id}`),
};

export default threatInsightAdmin;
